import { atom } from "recoil";
import { ILabel } from "../types/LabelTypes";

export const LabelAtom = atom<ILabel[] | undefined>({
  key: "Labels",
  default: [],
});
